import gql from 'graphql-tag';

export const queryForMOCEvents = gql`
  query queryForMOCEvents(
    $limit: Int
    $page: Int
    $query: MOCEventSortOrQuery
    $sort: MOCEventSortOrQuery
  ) {
    queryForMOCEvents(limit: $limit, page: $page, query: $query, sort: $sort) {
      items {
        id
        title
        eventType
        eventStatus
        eventCategories
        aors
        description
        document
        startDt
        endDt
        createdBy
        createdAt
        sapOutageNumber
        acknowledged
        businessUnits
      }
      totalRecords
    }
  }
`;
